import getDataSelector from 'core/utils/getDataSelector'
import DataKeys from 'k8s/DataKeys'

export const dataVolumesSelector = getDataSelector<DataKeys.DataVolumes>(
  DataKeys.DataVolumes,
  ['clusterId'],
  ['clusterId', 'namespace'],
)
